<template>
  <layout-main-inner title="订单管理">
    <layout-card-wrap :hasSlot="true">
      <template slot="form">
        <!-- <ent-auto-select
          v-model="config.vendorId"
          style="margin-right: 10px"
          :callback="()=> { handleCurrentChange(1) }" /> -->
        <el-input
          v-model="config.orderNumber"
          clearable
          style="width: 240px"
          placeholder="请输入订单号"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="订单号"
          width="160"
          prop="orderNumber"> </el-table-column>
        <el-table-column
          label="商品名称"
          min-width="200"
          prop="productNames"> </el-table-column>
        <el-table-column
          label="企业名称"
          min-width="130"
          prop="vendorName">
        </el-table-column>
        <el-table-column
          label="商品数量"
          width="100"
          prop="goodsCount">
        </el-table-column>
        <el-table-column
          label="收件人"
          min-width="200"
          prop="tradeType">
          <template slot-scope="{ row }">
            {{ row.deliveryName }}-{{ row.deliveryPhone }}-{{ row.detailedAddress }}
          </template>
        </el-table-column>
        <el-table-column
          key="8"
          label="备案时间"
          width="140"
          prop="createdTime">
          <template slot-scope="{ row }">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange">
      </el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
// import EntAutoSelect from '../../components/ent-auto-select.vue'
export default {
  name: 'ScmOrders',
  components: { },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        // isOriginalOrder: 1,
        pageNum: 1,
        pageSize: 10,
        orderNumber: '',
        vendorId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('zs/getoutstockorders', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
